<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="transctionInformation_tooltip_NAME"  :name="transctionInformation_tooltip_NAME" :description="transctionInformation_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row justify-content-center">
      <div class="col-sm-6 more-top-padding">
        <label for="currency">Currency</label>
        <tool-tip  v-on:updateToolTip="updateToolTip($event)" v-if="currency_tooltip_NAME"  :name="currency_tooltip_NAME" :description="currency_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
        <v-select
          id="currency"
          :disabled="isReadOnly || isPartnerAccount"
          v-model="transaction.currencyId"
          @input="getExchangeRate"
          :reduce="(currency) => currency.currencyId"
          label="name"
          :options="currencies"
          placeholder="Select currency"
        ></v-select>
      </div>
      <div class="col-sm-6 more-top-padding">
   
        <label for="exchangeRate">Exchange Rate</label>
        <tool-tip  v-on:updateToolTip="updateToolTip($event)" v-if="exchange_rate_tooltip_NAME"  :name="exchange_rate_tooltip_NAME" :description="exchange_rate_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
        <base-input
          id="exchangeRate"
          :disabled="isReadOnly || isPartnerAccount"
          v-model="transaction.exchangeRate" 
          name="exchangeRate"
          v-on:blur="limitFormatter"
          v-validate="'required'"
          @focus="backToInput2"
          @input="filterNumber($event)"
          type="currency"
          min="0"
          max="9999999999999999999"
          data-vv-as="Exchange Rate"
        ></base-input>
          <span v-show="errors.has('exchangeRate')" class="error"
          > 
         </span>
      </div>
      <div class="col-sm-6 more-top-padding">
        <label for="agreedReturnDate"
          >Agreed Return Date (Conclusion Date)</label
        >
        <el-date-picker
          id="agreedReturnDate"
          :disabled="isReadOnly || isPartnerAccount"
          format="dd-MMMM-yyyy"
          name="agreedReturnDate"
          v-model="transaction.agreedReturnDate"
          v-validate="returnDateRule"
          data-vv-as="Agreed Return Date"
          type="date"
           :editable="false"
          placeholder="Conclusion Date"
          :class="errors.has('agreedReturnDate') ? 'has-danger' : ''"
        >
        </el-date-picker>
          <span v-show="errors.has('agreedReturnDate')" class="error"
          >Agreed Return Date (Conclusion Date) is required
         </span>
      </div>
      <div class="col-sm-6 more-top-padding">
        <label for="notToExceed">Not To Exceed</label>
        <tool-tip  v-on:updateToolTip="updateToolTip($event)" v-if="not_to_exceed_tooltip_NAME"  :name="not_to_exceed_tooltip_NAME" :description="not_to_exceed_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
      
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          min="1"
          max="9999999999999999999"
          name="notToExceed"
           v-validate="userValidations.notToExceed"
          data-vv-as="Not To Exceed"
          v-model="transaction.notToExceed"
          v-on:blur="currencyFormatter"
          type="currency"
          @focus="backToInput" 
          @keypress="filterNumber($event)"
          @paste="onPaste"
           :error="getError('notToExceed')"
        ></base-input>
      </div>

      <div class="col-sm-6 more-top-padding">
        <label for="transactionSummary">Transaction Summary </label>
        <base-input
          id="transactionSummary"
          :disabled="isReadOnly || isPartnerAccount"
          v-model="transaction.transactionSummary"
          name="summary"
          v-validate="'max:300'"
          placeholder="Description of Logistics Support, Supplies, and Services"
          :error="getError('summary')"
        >
        </base-input>
      </div>
      <div class="col-sm-6 more-top-padding">
       <label for="PurchaseNumber">Purchase Order Number</label>
       <tool-tip  v-on:updateToolTip="updateToolTip($event)" v-if="purchase_order_tooltip_NAME"  :name="purchase_order_tooltip_NAME" :description="purchase_order_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
          <base-input
          :disabled="isReadOnly || isPartnerAccount"
            id="purchaseNumber"
            v-model="transaction.purchaseNumber"
            name="PurchaseNumber"
            v-validate="'max:300'"
            :error="getError('purchaseNumber')"
          >
        </base-input>
      </div>
  
    </div>
    
    <div class="row justify-content-center">
      <div class="col-sm-12 more-top-padding align-right">
        <base-button
          :disabled="isReadOnly || isPartnerAccount"
          type="primary"
          wide
          @click.native="submit"
          class="btn-next"
          >Save</base-button
        >
        <div class="clearfix"></div>
      </div>
    </div>
    <Notifications :notifications="notificationMessages"> </Notifications>
  </div>
</template>

  

<script>
import Notifications from "@/components/NotificationPlugin/Notifications.vue";
import Utility from "@/mixins/utility/utility";
import { mapGetters, mapActions } from "vuex";
import { Select, Option } from "element-ui";
import Util from "@/util/util";
import  toolTip  from "../../Tooltip";


export default {
  props: ["isReadOnly"],
  name: "TransactionInformation",
  mixins: [Utility],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Notifications,
  },
  data() {
    return {
      notificationMessages: [],
      currencies: [],
      priceInput: null ,
      currency_tooltip_NAME: '',
      currency_tooltip_DESCRIPTION: '',
      exchange_rate_tooltip_DESCRIPTION: '',
      exchange_rate_tooltip_NAME: '',
      not_to_exceed_tooltip_DESCRIPTION: '',
      not_to_exceed_tooltip_NAME: '',
      purchase_order_tooltip_DESCRIPTION: '',
      purchase_order_tooltip_NAME: '',
      transctionInformation_tooltip_NAME : '',
      transctionInformation_tooltip_DESCRIPTION : '',
        userValidations: {
       
        notToExceed: {
          required: true,
          min_currency: 0.01,
        }
      },
    };
  },
  async updated() {
    await this.getExchangeRate(
      this.selectUnitedStatesIfCurrencyIdIsNullOrZero()
    );
  },
  async mounted() {
   await this.getAllTooltips()
   await  this.getTransactionInformationStatus(this.orderIdFromRoute)
    // this.showTransactionInfoErrors()
   this.loadToolTips()
 },
 components: {
    toolTip
  },
  computed: {
    ...mapGetters({
      paymentMethods: "paymentmethod/paymentMethods",
      transaction: "transactionInformation/transactionInformation",
      transactionErrors: "transactionInformation/transactionInformationErrors",
      agreedDateEnabled: "transactionInformation/agreedDateEnabled",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    returnDateRule() {
      return this.agreedDateEnabled ? "required" : "";
    },
  },
  methods: {
    ...mapActions({
      saveTransactionInformation:
        "transactionInformation/saveTransactionInformation",
      getAgreedReturnDateEnabled:
        "transactionInformation/getAgreedReturnDateEnabled",
      getTransactionInformation:
        "transactionInformation/getTransactionInformation",
      getTransactionInformationStatus:
        "transactionInformation/getTransactionInformationStatus",
      resetTransactionInformation: "transactionInformation/clearData",
      getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const currencyToolTipInfo = this.toolTips.find(e => e.name === "Currency")
    const exchangeRateTooltipInfo = this.toolTips.find(e => e.name === "ExchangeRate")
    const notToExceedToolTipInfo = this.toolTips.find(e => e.name === "NotToExceed")
    const purchaseOrderToolTipInfo = this.toolTips.find(e => e.name === "PurchaseOrder")
    const transctionInformationVal = this.toolTips.find(e => e.name === "TransactionInfoModule")
    if(currencyToolTipInfo.status){
      this.currency_tooltip_DESCRIPTION = currencyToolTipInfo.description ? currencyToolTipInfo.description :  null
      this.currency_tooltip_NAME = currencyToolTipInfo.name ? currencyToolTipInfo.name :  null
    }
    if(exchangeRateTooltipInfo.status){
      this.exchange_rate_tooltip_DESCRIPTION = exchangeRateTooltipInfo.description ? exchangeRateTooltipInfo.description :  null
      this.exchange_rate_tooltip_NAME = exchangeRateTooltipInfo.name ? exchangeRateTooltipInfo.name :  null
    }
    if(notToExceedToolTipInfo.status){
      this.not_to_exceed_tooltip_DESCRIPTION = notToExceedToolTipInfo.description ? notToExceedToolTipInfo.description :  null
      this.not_to_exceed_tooltip_NAME = notToExceedToolTipInfo.name ? notToExceedToolTipInfo.name :  null
    }
    if(purchaseOrderToolTipInfo.status){
      this.purchase_order_tooltip_DESCRIPTION = purchaseOrderToolTipInfo.description ? purchaseOrderToolTipInfo.description :  null
      this.purchase_order_tooltip_NAME = purchaseOrderToolTipInfo.name ? purchaseOrderToolTipInfo.name :  null

    }
    if(transctionInformationVal.status){
    this.transctionInformation_tooltip_DESCRIPTION = transctionInformationVal.description ? transctionInformationVal.description: null
      this.transctionInformation_tooltip_NAME = transctionInformationVal.name ? transctionInformationVal.name: null
  }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    async getCurrencies() {  
            const response = await this.axios.get("/api/currencies");
            this.currencies = response.data;
        },
   filterNumber(evt) {
      // only allow number
      // to prevent extra chars, use event.keyCode === <charCode> || <repeat>
        evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      }

      // Prevent more than one decimal point
if (charCode === 46 && evt.target.value.includes(".")) {
  evt.preventDefault();
  return;
}

// Limit to 10 digits after the decimal point
if (evt.target.value.includes(".")) {
  var decimalPart = evt.target.value.split(".")[1];
  if (decimalPart && decimalPart.length >= 10) {
    evt.preventDefault();
    return;
  }
}
        return true
    },
    loaded() {
      this.getCurrencies();
      this.getTransactionInformation(this.orderIdFromRoute);
      this.getAgreedReturnDateEnabled(this.orderIdFromRoute);
    },
    backToInput2(event){
      if (this.exchangeRate){
        this.transaction.exchangeRate = this.exchangeRate
      }else{
        this.transaction.exchangeRate = event.target.value
      }
    },
    selectUnitedStatesIfCurrencyIdIsNullOrZero() {
      let result = null;

      if (
        !Util.isNull(this.transaction) &&
        !Util.isNullOrEmpty(this.currencies)
      ) {
        if (
          Util.isNull(this.transaction.currencyId) ||
          this.transaction.currencyId === 0
        ) {
          this.transaction.currencyId = this.currencies.filter(
            (item) => item.abbreviation === "USD"
          )[0].currencyId;
          result = this.transaction.currencyId;
        }
      }

      return result;
    },
    getExchangeRate(val) {
      if (
        !Util.isNull(val) &&
        !Util.isNull(this.currencies) &&
        !Util.isNull(this.transaction)
      ) {
        const currency = this.currencies.find(
          (currency) => currency.currencyId === val
        );
        if (Util.isNull(currency) || currency.toUsdollar === 1) {
          this.transaction.exchangeRate = "1.00";
        } else {
          this.transaction.exchangeRate = currency.toUsdollar;
        }
      }
    },
    showAlertDialog(alertHeaderText, alertBodyText) {
      this.$toast.error(`${alertHeaderText}: ${alertBodyText}`);
    },
    showTransactionInfoErrors () {
      if(this.transactionErrors.length > 0 ) {
        this.transactionErrors.forEach(error => this.$toast.error(error))
      }
    },
    submit(e) {
      if(this.orderIdFromRoute === 0) {
        this.showAlertDialog("Alert", "Please complete the Pre Order Details Module First!");
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          let ctx = this;
          //use ctx this looses its context in a callback
          ctx
            .saveTransactionInformation(ctx.orderIdFromRoute)
            .then((result) => {
              ctx.getTransactionInformationStatus(ctx.orderIdFromRoute).then(() => {
                    ctx.showTransactionInfoErrors();
                  });
              ctx.getTransactionInformation(ctx.orderIdFromRoute);
            })
            .catch((err) => {
              this.showAlertDialog("Alert", `Error Occured ${err}`);

            });
        } else {
          this.showAlertDialog("Alert", "Please fill the form fields first.");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    currencyFormatter(event) {
      this.priceInput = event.target.value
      if(this.priceInput){
      this.transaction.notToExceed = parseFloat(this.priceInput).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
      }
    },
     onPaste(e) {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    const clean = pasted.replace(/[a-zA-Z]/g, '');
    document.execCommand('insertText', false, clean);
  },
    limitFormatter(event){
      this.exchangeRate = event.target.value
      let test = new Intl.NumberFormat('en-US', { 
        currency: 'USD', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 10 }).format(event.target.value);
      this.transaction.exchangeRate = test.toString();
      this.$validator.validateAll();
    },
    backToInput(event){
      if(this.priceInput){
        this.transaction.notToExceed =  this.priceInput
      }else{
        this.transaction.notToExceed = event.target.value
      }
    },
  },
};
</script>

<style></style>
